import React, { Component } from 'react';
import { observer, Provider, inject } from 'mobx-react';
import { autorun } from 'mobx';
import { HomeDetailsStore } from './homedetails.store';
import { HomeDetailsComponent } from './homedetails.component';
import HomeDetailsForm from './homedetails.form';

@inject('appStore', 'routerStore', 'gettingStartedStore', 'startStore')
@observer
export class HomeDetailsProvider extends Component {
    store;

    disabledRun;

    hasCouncils = false;

    constructor(props) {
        super(props);
        const { appStore, routerStore, match, startStore, gettingStartedStore } = props,
            { history } = routerStore;

        appStore.setURLProps(match);
        appStore.clearError();

        this.store = new HomeDetailsStore({
            appStore,
            startStore
        });

        this.store.initializeCouncils();

        this.form = new HomeDetailsForm({
            store: this.store,
            appStore: appStore
        });

        this.disposeForm = autorun(() => {
            if (
                !appStore.loading &&
                appStore.userData &&
                appStore.userData.homedetails
            ) {
                appStore.hydrateFormFields(
                    appStore.userData.homedetails,
                    'homedetails',
                    this.form
                );
            }

            // in  an autorun so the data can be populated after a 'back' action
            if (
                appStore.councils &&
                appStore.councils.length > 0 &&
                !this.hasCouncils
            ) {
                this.setCouncils(appStore.councils);
                this.hasCouncils = true;
            }

            if (
                !this.disabledRun &&
                gettingStartedStore.switchReadOnly()
            ) {
                this.form.disableFieldEditing();
                this.store.setIsReadOnly(true);
                this.disabledRun = true;
            }

            if (this.store.goNext) {
                this.store.goNext = false;
                history.push({ pathname: '/gettingstarted/floorarea', state: { transition: 'forward' } });
            }
        });
    }

    componentWillUnmount() {
        this.disposeForm();
    }

    /**
     * Map our region objects to councils and regions to populate the form selects
     * @param value
     */
    setCouncils(value) {
        this.form.allCouncils = value.map(obj => {
            const result = {};
            result[obj.Region] = obj.Council;
            return result;
        });

        this.form.regions = value.map(obj => {
            return obj.Region;
        })
            .filter((value, index, self) => {
                return self.indexOf(value) === index;
            })
            .sort();

        // return values and then remove duplicates
        this.form.filteredCouncils = this.form.allCouncils
            .map(obj => {
                return Object.values(obj)[0]; // return value
            })
            .filter((value, index, self) => {
                // remove duplicates
                return self.indexOf(value) === index;
            })
            .sort();
    }

    render() {
        return (
            <Provider form={this.form} store={this.store}>
                <HomeDetailsComponent key='homedetails' />
            </Provider>
        );
    }
}
